import { List, Map } from 'immutable';
import {
  records as jobsRecords,
  types as jobsTypes,
} from '@saucelabs/sl-module-jobs';

import * as types from './types';


const initialState = new Map({
  failedJobs: new Map(),
  expandedBuilds: new List(),
});


const buildCardReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.TOGGLE_BUILD_CARD: {
      const index = state.get('expandedBuilds').indexOf(payload);
      return index === -1 ?
        state.update('expandedBuilds', (expandedBuilds) => expandedBuilds.push(payload)) :
        state.update('expandedBuilds', (expandedBuilds) => expandedBuilds.delete(index));
    }
    case jobsTypes.FAILED_JOBS_GET.SUCCESS: {
      if (!payload.length) {
        return state;
      }
      const jobs = payload.map((job) => new jobsRecords.JobRecord(job));
      return state.setIn(['failedJobs', jobs[0].build], jobs);
    }
    default:
      return state;
  }
};

export default buildCardReducer;
